//const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://test.api.checkstall.com/api/v2';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.checkstall.com/api/v2';
//const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://192.168.0.101:8000/api/v2';

const resolveWebAppUrl = () => {
  if (process.env.REACT_APP_WEB_APP_URL) {
    return process.env.REACT_APP_WEB_APP_URL;
  }

  if (typeof window === 'undefined') {
    return 'https://app.checkstall.com';
  }

  const hostname = window.location.hostname || '';
  const isLocalHost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('192.168.') ||
    hostname.startsWith('10.') ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname);

  if (isLocalHost) {
    return 'http://localhost:8081';
  }

  if (hostname.includes('test.') || hostname.includes('staging.')) {
    return 'https://test.app.checkstall.com';
  }

  return 'https://app.checkstall.com';
};

const WEB_APP_URL = resolveWebAppUrl();

const buildUrl = (endpoint) => {
  if (!endpoint) {
    return API_BASE_URL;
  }
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    return endpoint;
  }
  if (!endpoint.startsWith('/')) {
    return `${API_BASE_URL}/${endpoint}`;
  }
  return `${API_BASE_URL}${endpoint}`;
};

export const apiRequest = async (endpoint, options = {}) => {
  const { getMarketingHeaders } = await import('./marketingAttribution');
  const url = buildUrl(endpoint);

  const headers = {
    'Content-Type': 'application/json',
    ...getMarketingHeaders(),
    ...(options.headers || {}),
  };

  const config = {
    method: options.method || 'GET',
    ...options,
    headers,
  };

  if (options.body && typeof options.body === 'object' && !(options.body instanceof FormData)) {
    config.body = JSON.stringify(options.body);
  }

  let response;

  try {
    response = await fetch(url, config);
  } catch (error) {
    const networkError = new Error(error.message || 'Network error');
    networkError.response = {
      status: 0,
      data: { message: error.message },
    };
    throw networkError;
  }

  let data = null;

  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const error = new Error(
      (data && (data.message || data.detail)) || 'Request failed'
    );
    error.response = {
      status: response.status,
      data,
    };
    throw error;
  }

  return { status: response.status, data };
};

export { API_BASE_URL, WEB_APP_URL };

export default apiRequest;

